// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-3JRvt";
var _3 = "root_insurance-CazXq";
var _4 = "header-5xMZ3";
var _5 = "header__icon-18d1Y";
var _6 = "header__badge-23VOw";
var _7 = "header__title-2KsvP";
var _8 = "content-3KdnR";
var _9 = "contentWrapper-1vlGv";
var _a = "title-1p3uP";
var _b = "description-3iJrR";
var _c = "options-2TCqJ";
var _d = "footer-L5dfs";
var _e = "footerPrice-18HmA";
var _f = "popular-1tMdI";
var _10 = "bottomPrice-3yEiT";
var _11 = "label-1XVjm";
var _12 = "label__agreement-3-T_G";
var _13 = "selectButton-39DPB";
var _14 = "confirmed-2dxEM";
var _15 = "moreInfo-2ufwF";
var _16 = "moreInfo_loading-zGYTb";
var _17 = "infoIcon-27AFo";
var _18 = "linksWrapper-wEG05";
export { _1 as "__esModule", _2 as "root", _3 as "root_insurance", _4 as "header", _5 as "header__icon", _6 as "header__badge", _7 as "header__title", _8 as "content", _9 as "contentWrapper", _a as "title", _b as "description", _c as "options", _d as "footer", _e as "footerPrice", _f as "popular", _10 as "bottomPrice", _11 as "label", _12 as "label__agreement", _13 as "selectButton", _14 as "confirmed", _15 as "moreInfo", _16 as "moreInfo_loading", _17 as "infoIcon", _18 as "linksWrapper" }
export default { "__esModule": _1, "root": _2, "root_insurance": _3, "header": _4, "header__icon": _5, "header__badge": _6, "header__title": _7, "content": _8, "contentWrapper": _9, "title": _a, "description": _b, "options": _c, "footer": _d, "footerPrice": _e, "popular": _f, "bottomPrice": _10, "label": _11, "label__agreement": _12, "selectButton": _13, "confirmed": _14, "moreInfo": _15, "moreInfo_loading": _16, "infoIcon": _17, "linksWrapper": _18 }
